module.exports = __webpack_public_path__ + "img/no-user.ae4b0b0e.png";